import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-12 text-sm font-display font-semibold text-gray-700 text-center" }
const _hoisted_2 = { class: "cursor-pointer text-indigo-600 hover:text-indigo-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.textOneToBeRendered) + " ", 1),
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_component_router_link, { to: _ctx.path }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.textTwoToBeRendered), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}